module.exports = __webpack_public_path__ + "static/media/02_hero_desktop.b99db853.jpg";